import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/ict-procurement/ICTProcurementContent.tsx");
